import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { useUser } from '@repo/cf-user/hooks/use-user-data'
import { decodeHtmlEntities } from 'utils/decode-html-entities' // TODO: Temporary, we are going to add a shared sanitiseInput in the frontend that also takes care of decoding

export const HeaderSidebar = () => {
  const t = useTranslations('pages.my_account.sidebar')
  const { data } = useUser()

  return (
    <>
      <div className="bg-cf-purple-600 relative h-11 w-full">
        {data?.avatarUrl ? (
          <Image
            src={data?.avatarUrl}
            alt="Your avatar"
            width={120}
            height={120}
            className="absolute left-[calc(50%-28px)] top-4 size-14 overflow-hidden rounded-full"
          />
        ) : (
          <div className="absolute left-[calc(50%-28px)] top-4 size-14 overflow-hidden rounded-full bg-gray-900" />
        )}
      </div>
      <div className="mt-10 flex w-full flex-col items-center justify-start gap-2">
        <div className="flex flex-row items-center justify-center truncate">
          <p className="text-16 whitespace-normal px-4 text-center font-semibold [word-break:break-word]">
            {t('greetings', {
              name: decodeHtmlEntities(data?.firstName || ''),
            })}
          </p>
        </div>
        <p className="text-14 text-gray-200">
          {t('info_account')} #{data?.id}
        </p>
      </div>
    </>
  )
}
